import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAllCities, getAllDistricts } from '../store/slices/addressSlice';
import { OptionModel } from '../common/types/OptionModel';
import { ThunkDispatch } from 'redux-thunk';
import { errorMessages } from '../constants/messages/errorMessages';

const useFetchCityDistrict = (
    selectedCities: any[] | null,
    setCityOptions: (options: OptionModel[]) => void,
    setFilteredDistrictOptions: (options: OptionModel[]) => void,
) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    useEffect(() => {
        const fetchCities = async () => {
            try {
                const resultActions = await dispatch(getAllCities());
                if (getAllCities.fulfilled.match(resultActions)) {
                    const citiesData = resultActions.payload;
                    const options: OptionModel[] = citiesData.map((item: any) => ({
                        value: item.cityid,
                        label: item.city,
                    }));
                    setCityOptions(options);
                } else {
                  
                }
            } catch (error) {
              
            }
        };

        fetchCities();
    }, [dispatch, setCityOptions]);

    useEffect(() => {
        const fetchDistricts = async () => {
            if (selectedCities?.length === 0) {
                setFilteredDistrictOptions([]);
                return;
            }

            try {
                const resultAction = await dispatch(getAllDistricts());
                if (getAllDistricts.fulfilled.match(resultAction)) {
                    const districtsData = resultAction.payload;

                    const selectedCityValues: any = selectedCities?.map((city: any) => city.value);
                    const selectedCityLabels = selectedCities?.reduce((acc: any, city: any) => {
                        acc[city.value] = city.label;
                        return acc;
                    }, {});

                    const filteredDistricts = districtsData.filter((district: any) =>
                        selectedCityValues.includes(district.cityid)
                    );

                    if (selectedCities?.length === 1) {
                        setFilteredDistrictOptions(filteredDistricts.map((district: any) => ({
                            value: district.districtid,
                            label: district.districtname,
                        })));
                    } else {
                        setFilteredDistrictOptions(filteredDistricts.map((district: any) => ({
                            value: district.districtid,
                            label: `${selectedCityLabels[district.cityid]} - ${district.districtname}`,
                        })));
                    }
                } else {
               
                }
            } catch (error) {
               
            }
        };

        fetchDistricts();
    }, [selectedCities, dispatch, setFilteredDistrictOptions]);
};

export default useFetchCityDistrict;
